import { Component, ElementRef, EventEmitter, HostListener, Input, NgModule, Output } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
class StickyComponent {
    /**
     * @param {?} element
     */
    constructor(element) {
        this.element = element;
        this.zIndex = 10;
        this.width = 'auto';
        this.offsetTop = 0;
        this.offsetBottom = 0;
        this.start = 0;
        this.stickClass = 'sticky';
        this.endStickClass = 'sticky-end';
        this.mediaQuery = '';
        this.parentMode = true;
        this.orientation = 'none';
        this.activated = new EventEmitter();
        this.deactivated = new EventEmitter();
        this.reset = new EventEmitter();
        this.isStuck = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.elem = this.element.nativeElement;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        // define scroll container as parent element
        this.container = this.elem.parentNode;
        this.defineOriginalDimensions();
        this.sticker();
    }
    /**
     * @return {?}
     */
    onChange() {
        this.sticker();
    }
    /**
     * @return {?}
     */
    defineOriginalDimensions() {
        this.originalCss = {
            zIndex: this.getCssValue(this.elem, 'zIndex'),
            position: this.getCssValue(this.elem, 'position'),
            top: this.getCssValue(this.elem, 'top'),
            right: this.getCssValue(this.elem, 'right'),
            left: this.getCssValue(this.elem, 'left'),
            bottom: this.getCssValue(this.elem, 'bottom'),
            width: this.getCssValue(this.elem, 'width'),
        };
        if (this.width === 'auto') {
            this.width = this.originalCss.width;
        }
    }
    /**
     * @return {?}
     */
    defineDimensions() {
        /** @type {?} */
        let containerTop = this.getBoundingClientRectValue(this.container, 'top');
        this.windowHeight = window.innerHeight;
        this.elemHeight = this.getCssNumber(this.elem, 'height');
        this.containerHeight = this.getCssNumber(this.container, 'height');
        this.containerStart = containerTop + this.scrollbarYPos() - this.offsetTop + this.start;
        if (this.parentMode) {
            this.scrollFinish = this.containerStart - this.start - this.offsetBottom + (this.containerHeight - this.elemHeight);
        }
        else {
            this.scrollFinish = document.body.offsetHeight;
        }
    }
    /**
     * @return {?}
     */
    resetElement() {
        this.elem.classList.remove(this.stickClass);
        Object.assign(this.elem.style, this.originalCss);
        this.reset.next(this.elem);
    }
    /**
     * @return {?}
     */
    stuckElement() {
        this.isStuck = true;
        this.elem.classList.remove(this.endStickClass);
        this.elem.classList.add(this.stickClass);
        Object.assign(this.elem.style, {
            zIndex: this.zIndex,
            position: 'fixed',
            top: this.offsetTop + 'px',
            right: 'auto',
            bottom: 'auto',
            left: this.getBoundingClientRectValue(this.elem, 'left') + 'px',
            width: this.getCssValue(this.elem, 'width')
        });
        this.activated.next(this.elem);
    }
    /**
     * @return {?}
     */
    unstuckElement() {
        this.isStuck = false;
        this.elem.classList.add(this.endStickClass);
        this.container.style.position = 'relative';
        Object.assign(this.elem.style, {
            position: 'absolute',
            top: 'auto',
            left: 'auto',
            right: this.getCssValue(this.elem, 'float') === 'right' || this.orientation === 'right' ? 0 : 'auto',
            bottom: this.offsetBottom + 'px',
            width: this.getCssValue(this.elem, 'width')
        });
        this.deactivated.next(this.elem);
    }
    /**
     * @return {?}
     */
    matchMediaQuery() {
        if (!this.mediaQuery)
            return true;
        return (window.matchMedia('(' + this.mediaQuery + ')').matches ||
            window.matchMedia(this.mediaQuery).matches);
    }
    /**
     * @return {?}
     */
    sticker() {
        // check media query
        if (this.isStuck && !this.matchMediaQuery()) {
            this.resetElement();
            return;
        }
        /** @type {?} */
        let currentContainerHeight = this.getCssNumber(this.container, 'height');
        if (currentContainerHeight !== this.containerHeight) {
            this.defineDimensions();
        }
        // check if the sticky element is above the container
        if (this.elemHeight >= currentContainerHeight) {
            return;
        }
        /** @type {?} */
        let position = this.scrollbarYPos();
        // unstick
        if (this.isStuck && (position < this.containerStart || position > this.scrollFinish) || position > this.scrollFinish) {
            this.resetElement();
            if (position > this.scrollFinish)
                this.unstuckElement();
            this.isStuck = false;
        }
        else if (position > this.containerStart && position < this.scrollFinish) {
            this.stuckElement();
        }
    }
    /**
     * @return {?}
     */
    scrollbarYPos() {
        return window.pageYOffset || document.documentElement.scrollTop;
    }
    /**
     * @param {?} element
     * @param {?} property
     * @return {?}
     */
    getBoundingClientRectValue(element, property) {
        /** @type {?} */
        let result = 0;
        if (element && element.getBoundingClientRect) {
            /** @type {?} */
            let rect = element.getBoundingClientRect();
            result = (typeof rect[property] !== 'undefined') ? rect[property] : 0;
        }
        return result;
    }
    /**
     * @param {?} element
     * @param {?} property
     * @return {?}
     */
    getCssValue(element, property) {
        /** @type {?} */
        let result = '';
        if (typeof window.getComputedStyle !== 'undefined') {
            result = window.getComputedStyle(element, '').getPropertyValue(property);
        }
        else if (typeof element.currentStyle !== 'undefined') {
            result = element.currentStyle[property];
        }
        return result;
    }
    /**
     * @param {?} element
     * @param {?} property
     * @return {?}
     */
    getCssNumber(element, property) {
        if (typeof element === 'undefined')
            return 0;
        return parseInt(this.getCssValue(element, property), 10) || 0;
    }
}
StickyComponent.ɵfac = function StickyComponent_Factory(t) { return new (t || StickyComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
StickyComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StickyComponent, selectors: [["sticky"], ["", "sticky", ""]], hostBindings: function StickyComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function StickyComponent_scroll_HostBindingHandler($event) { return ctx.onChange($event); }, false, ɵngcc0.ɵɵresolveWindow)("resize", function StickyComponent_resize_HostBindingHandler($event) { return ctx.onChange($event); }, false, ɵngcc0.ɵɵresolveWindow)("orientationchange", function StickyComponent_orientationchange_HostBindingHandler($event) { return ctx.onChange($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { zIndex: ["sticky-zIndex", "zIndex"], width: ["sticky-width", "width"], offsetTop: ["sticky-offset-top", "offsetTop"], offsetBottom: ["sticky-offset-bottom", "offsetBottom"], start: ["sticky-start", "start"], stickClass: ["sticky-class", "stickClass"], endStickClass: ["sticky-end-class", "endStickClass"], mediaQuery: ["sticky-media-query", "mediaQuery"], parentMode: ["sticky-parent", "parentMode"], orientation: ["sticky-orientation", "orientation"], sticky: "sticky" }, outputs: { activated: "activated", deactivated: "deactivated", reset: "reset" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function StickyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/** @nocollapse */
StickyComponent.ctorParameters = () => [
    { type: ElementRef }
];
StickyComponent.propDecorators = {
    sticky: [{ type: Input, args: ['sticky',] }],
    zIndex: [{ type: Input, args: ['sticky-zIndex',] }],
    width: [{ type: Input, args: ['sticky-width',] }],
    offsetTop: [{ type: Input, args: ['sticky-offset-top',] }],
    offsetBottom: [{ type: Input, args: ['sticky-offset-bottom',] }],
    start: [{ type: Input, args: ['sticky-start',] }],
    stickClass: [{ type: Input, args: ['sticky-class',] }],
    endStickClass: [{ type: Input, args: ['sticky-end-class',] }],
    mediaQuery: [{ type: Input, args: ['sticky-media-query',] }],
    parentMode: [{ type: Input, args: ['sticky-parent',] }],
    orientation: [{ type: Input, args: ['sticky-orientation',] }],
    activated: [{ type: Output }],
    deactivated: [{ type: Output }],
    reset: [{ type: Output }],
    onChange: [{ type: HostListener, args: ['window:scroll', ['$event'],] }, { type: HostListener, args: ['window:resize', ['$event'],] }, { type: HostListener, args: ['window:orientationchange', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyComponent, [{
        type: Component,
        args: [{
                selector: 'sticky,[sticky]',
                template: '<ng-content></ng-content>'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { zIndex: [{
            type: Input,
            args: ['sticky-zIndex']
        }], width: [{
            type: Input,
            args: ['sticky-width']
        }], offsetTop: [{
            type: Input,
            args: ['sticky-offset-top']
        }], offsetBottom: [{
            type: Input,
            args: ['sticky-offset-bottom']
        }], start: [{
            type: Input,
            args: ['sticky-start']
        }], stickClass: [{
            type: Input,
            args: ['sticky-class']
        }], endStickClass: [{
            type: Input,
            args: ['sticky-end-class']
        }], mediaQuery: [{
            type: Input,
            args: ['sticky-media-query']
        }], parentMode: [{
            type: Input,
            args: ['sticky-parent']
        }], orientation: [{
            type: Input,
            args: ['sticky-orientation']
        }], activated: [{
            type: Output
        }], deactivated: [{
            type: Output
        }], reset: [{
            type: Output
        }], 
    /**
     * @return {?}
     */
    onChange: [{
            type: HostListener,
            args: ['window:scroll', ['$event']]
        }, {
            type: HostListener,
            args: ['window:resize', ['$event']]
        }, {
            type: HostListener,
            args: ['window:orientationchange', ['$event']]
        }], sticky: [{
            type: Input,
            args: ['sticky']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class StickyModule {
}
StickyModule.ɵfac = function StickyModule_Factory(t) { return new (t || StickyModule)(); };
StickyModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: StickyModule });
StickyModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyModule, [{
        type: NgModule,
        args: [{
                declarations: [StickyComponent],
                exports: [StickyComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StickyModule, { declarations: [StickyComponent], exports: [StickyComponent] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { StickyComponent, StickyModule };

